































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryPeriodResponse from '@/model/response/DeliveryPeriodResponse'
import FilterDeliveryPeriod from '@/components/filters/FilterDeliveryPeriod.vue'
import DeliveryPeriodRequest from '@/model/request/DeliveryPeriodRequest'
import {AppConfig} from '@/config/app.config'
import {snakeCase} from 'lodash'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryPeriod.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDeliveryPeriod},
})
export default class ReportsDeliveryPeriodView extends Mixins(MixinFilter) {
  filter = new DeliveryPeriodRequest()
  collection = new PageCollection(DeliveryPeriodResponse, this.filter, 12)
  AppConfig = AppConfig

  created() {
    if (this.$route.query.from === undefined) {
      this.filter.fromDate = moment().subtract(2, 'month').startOf('month').format()
    }

    if (this.$route.query.to === undefined) {
      this.filter.toDate = moment().endOf('month').format()
    }
  }

async downloadData(xlsx: boolean) {
  const reportEndpoint = '/user/indicador/entrega-por-periodo/csv'
  if (!xlsx) {
      const csv = new PageCollection(DeliveryPeriodResponse, this.filter, null, null)
      csv.endpoint = reportEndpoint
      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('view.reports.deliveryPeriod.title')))
  } else {
      await $.await.run(() => Helper.downloadXlsx(
        $.t('view.reports.deliveryPeriod.title'),
        reportEndpoint,
        this.filter,
        DeliveryPeriodResponse,
        'DeliveryPeriodResponse',
        ), 'download')
  }
}
}
